import Http from '../http'
// 主动安全模块API
export default {
  // 驾驶员行为分析
  // 驾驶员行为列表汇总
  driverBehaviorAnalysis(params) {
    return Http.post('/driver/driverBehaviorAnalysis.do', params)
  },
  // 导出-驾驶员行为列表
  exportDriverBehaviorAnalysis() {
    return '/export/exportDriverBehaviorAnalysis.do'
  },
  // 驾驶员行为列表汇总明细
  getDriverBehaviorList(params) {
    return Http.post('/driver/getDriverBehaviorList.do', params)
  },
  // 驾驶员评分
  // 获取评分设置
  getScoreSetting(params) {
    return Http.post('/driver/getScoreSetting.do', params)
  },
  // 更新评分设置
  saveScoreSetting(params) {
    return Http.post('/driver/saveScoreSetting.do', params)
  },
  // 获取驾驶员评分列表
  getScoreList(params) {
    return Http.post('/driver/driverScoreList.do', params)
  },
  // 报警统计分析
  // 企业统计分析
  getCompanyStatistics(params) {
    return Http.post('/statistics/company.do', params)
  },
  // 驾驶员统计分析
  getDriverStatistics(params) {
    return Http.post('/statistics/driver.do', params)
  },
  // 车辆统计分析
  getVehicleStatistics(params) {
    return Http.post('/statistics/vehicle.do', params)
  },
  getActiveSafetyOverview (params) {
    return Http.post('/assess/index.do', params)
  },
  // ----------------808报警附件数据格式 begin -----------------
  // 808报警附件数据格式列表
  getFileTypeRuleList(params) {
    return Http.post('/alarmFileAction/list.do', params)
  },
  // 添加
  addFileTypeRule(params) {
    return Http.post('/alarmFileAction/add.do', params)
  },
  // 保存编辑
  saveFileTypeRule(params) {
    return Http.post('/alarmFileAction/update.do', params)
  },
  // 删除
  deleteFileTypeRule(params) {
    return Http.post('/alarmFileAction/delete.do', params)
  },
  // 获取单个信息
  getSingleFileTypeRule(params) {
    return Http.post('/alarmFileAction/get.do', params)
  },
  // ----------------车辆，808报警，附件数据规则关联 begin -----------------
  // 车辆，808报警，附件数据规则关联列表列表
  devArmFilePermitList(params) {
    return Http.post('/alarmFileAction/devArmFilePermitList.do', params)
  },
  // 添加
  addDevArmFilePermit(params) {
    return Http.post('/alarmFileAction/addDevArmFilePermit.do', params)
  },
  // 保存编辑
  updateDevArmFilePermit(params) {
    return Http.post('/alarmFileAction/updateDevArmFilePermit.do', params)
  },
  // 删除
  deleteDevArmFilePermit(params) {
    return Http.post('/alarmFileAction/deleteDevArmFilePermit.do', params)
  },
  // 获取单个信息
  getDevArmFilePermit(params) {
    return Http.post('/alarmFileAction/getDevArmFilePermit.do', params)
  },
  // 根据文件类型获取信息
  getFileTypeList(params) {
    return Http.post('/alarmFileAction/getFileTypeList.do', params)
  },
  // BSD明细列表
  getBSDList(params) {
    return Http.post('/bsd/list.do', params)
  },
  // 导出 BSD明细列表
  exportBSDList() {
    return '/export/exportBsd.do'
  },
  // BSD统计列表
  getBSDSummary(params) {
    return Http.post('/bsd/summary.do', params)
  },
  // 主动安全明细列表
  getActivesafeList(params) {
    return Http.post('/activeSafe/list.do', params)
  },

  // 健康码查询列表
  getHealthCodeList(params) {
    return Http.post('/activeSafe/getHealthCodeList.do', params)
  },
  // 导出健康码列表
  exportHealthCode() {
    return '/export/exportHealthCode.do'
  },
  // 导出 主动安全明细列表
  exportActivesafeList() {
    return '/export/exportActiveSafe.do'
  },
  // 主动安全统计列表
  getActivesafeSummary(params) {
    return Http.post('/activeSafe/summary.do', params)
  },
  // 主动安全报警汇总
  sumList(params) {
    return Http.post('/activeSafety/sumList.do', params)
  },
  // 导出 主动安全报警汇总
  exportSumList() {
    return '/activeSafety/exportSumList.do'
  },
  // 获取报警详情
  infoByDev(params) {
    return Http.post('/activeSafety/infoByDev.do', params)
  },
  // 导出 获取报警详情
  exportInfoByDev() {
    return '/activeSafety/infoByDev.do'
  }
}



// WEBPACK FOOTER //
// ./src/services/api/activeSafety.js